import { Route, Router, Routes } from 'react-router-dom';
import './App.css';
import Home from './Screen/home';
import Contact from './Screen/contact';
import Invitation from './Screen/invitation';
import ErrorSnackbar from "./Component/errorSnackbar";
import SuccessSnackbar from "./Component/successSnackbar";
import Volunteer from './Screen/volunteer';
import OurTeam from './Screen/ourTeam';
import PartnerSupport from './Screen/partnerSupport';


function App() {
  return (
    <div className="App">
      <SuccessSnackbar />
      <ErrorSnackbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Invitation" element={<Invitation />} />
        <Route path='/Volunteer' element={<Volunteer />} />
        <Route path='/OurTeam' element={<OurTeam />} />
        <Route path='/PartnerSupport' element={<PartnerSupport />} />
        {/* <Route path="*" element={<WIP />} /> */}
      </Routes>
    </div>
  );
}

export default App;
